import panzoom from 'panzoom'
import { Collection, CANVAS_GRID_COLUMNS_COUNT } from './Collection.js'

function updateDots(root) {
  const dotsEl = root?.Dots
  if (!dotsEl?.node) return

  const gs = root.context?.globalScope
  const { positions } = gs || {}
  if (!positions) return

  const { x, y, scale } = positions
  const baseSize = 20
  const bgSize = scale * baseSize
  dotsEl.node.style.backgroundPosition = `${x % bgSize}px ${y % bgSize}px`
  dotsEl.node.style.backgroundSize = `${bgSize}px ${bgSize}px`
}

export { Collection }

export const CanvasScene = {
  minWidth: `${CANVAS_GRID_COLUMNS_COUNT * 574}px`,
  minHeight: '55000px',
  userSelect: 'none',
  position: 'relative',

  Collection,

  onRender: (el) => {
    if (el.__panzoomInitialized) return
    el.__panzoomInitialized = true

    const root = el.parent
    const gs = el.context?.globalScope || {}

    const instance = panzoom(el.node, {
      minZoom: 0.035,
      maxZoom: 1.99,
      zoomSpeed: 1,
      bounds: true,
      boundsPadding: 0.25,
      onDoubleClick: (e) => {
        e.preventDefault()
        e.stopPropagation()
        return false
      },
      beforeMouseDown: () => !gs.panningMode,
      beforeWheel: (e) => {
        e.preventDefault()
        e.stopPropagation()
        const { x, y, scale } = instance.getTransform()
        const isPinch = e.metaKey || e.ctrlKey || gs.panningMode
        if (!isPinch) instance.moveTo(x - e.deltaX, y - e.deltaY)
        gs.positions = { ...gs.positions, x, y, scale }
        updateDots(root)
        return !isPinch
      }
    })

    gs.panzoomInstance = instance

    const saved = localStorage.getItem('canvas_position')
    if (saved) {
      try {
        const { x, y, scale } = JSON.parse(saved)
        instance.moveTo(x || 0, y || 0)
        instance.zoomAbs(x || 0, y || 0, scale || 0.35)
      } catch (e) {}
    } else {
      // Seed both the library's internal state (so wheel/drag start from
      // the right transform) AND the element's style via DOMQL: panzoom's
      // rAF loop defers the first DOM write until a transform *changes*,
      // which leaves the 55k × 55k scene at identity until the user
      // interacts and the viewport is filled by a single 1722×1722
      // thumbnail. Writing via `el.update({style})` keeps the DOM update
      // inside DOMQL's v3.14 update channel instead of reaching for
      // `el.node.style` directly.
      instance.zoomAbs(0, 0, 0.35)
      instance.moveTo(40, 40)
      // `transform` / `transformOrigin` aren't in DOMQL v3.14's CSS_PROPS
      // registry, so they must go through the `style:` channel to reach
      // the DOM.
      el.update({ style: { transformOrigin: '0 0', transform: 'matrix(0.35, 0, 0, 0.35, 40, 40)' } })
    }

    // Center on first box after thumbnails render
    setTimeout(() => {
      if (saved) return
      const first = el.Collection?.node?.children?.[0]
      if (!first) return
      const rect = first.getBoundingClientRect()
      const { x, y } = instance.getTransform()
      instance.moveTo(x - rect.left + 40, y - rect.top + 40)
    }, 3000)

    instance.on('transform', () => {
      const { x, y, scale } = instance.getTransform()
      gs.positions = { ...gs.positions, x, y, scale }
      gs.isPanning = true

      clearTimeout(gs._panEndTimeout)
      gs._panEndTimeout = setTimeout(() => {
        gs.isPanning = false
      }, 65)

      updateDots(root)

      gs._panStoreLimit = (gs._panStoreLimit || 0) + 1
      if (gs._panStoreLimit > 15) {
        gs._panStoreLimit = 0
        localStorage.setItem('canvas_position', JSON.stringify({ x, y, scale }))
      }
    })

    updateDots(root)
  }
}
